import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { AccountRegisterRequestBody, AccountRegisterResponse } from "./types";

export class AccountRegisterAPI extends BaseAPI<
  AccountRegisterRequestBody,
  AccountRegisterResponse
> {
  protected route = ApiRoutes.account.register;
  protected method = RequestMethod.POST;
}
